export default __webpack_public_path__ + "5f03984637ac1e2b6605b0c136523425.svg";